"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerVendor = void 0;
const common_1 = require("../../common");
class PartnerVendor extends common_1.MongoSubDocument {
}
exports.PartnerVendor = PartnerVendor;
//# sourceMappingURL=partner-vendor.model.js.map